import { Avatar, CardActionArea } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { handleFollowing } from 'APIs/utils';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import IC_CHECK_WHITE from 'assets/icons/ic_check_white.svg';
import IC_FOLLOW from 'assets/icons/ic_person_white.svg';
import IC_VERIFY from 'assets/icons/verify.svg';
import { NormalButton } from 'components/atoms/Button';
import { selectAuth } from 'features/auth/authSlice';
import { UserData } from 'interfaces/UserData.interface';
import * as React from 'react';
// import './Card.css';
import { useNavigate } from 'react-router-dom';
import { v4 } from 'uuid';
const ArtistAvatar = styled(Avatar)(({ theme }) => ({
  position: 'absolute',
  top: '-40px',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // border: "5px solid #323746"
}));

const TitleText = styled(Typography)`
  color: #ffffff;
  font-size: 1.9rem;
  font-weight: bold;
`;
const NameText = styled(Typography)(() => ({
  color: '#36899f',
  fontWeight: 'normal',
}));

const ParaText = styled(Typography)(() => ({
  color: '#ffffff',
  fontSize: '1rem',
  fontWeight: 'lighter',
  margin: '20px 0px',
}));

const FollowersText = styled(ParaText)(() => ({
  color: '#ddb930',
}));
// const Icon = styled('img')(() => ({
//   width: '16px',
//   height: '16px',
//   marginRight: '10px',
// }));
const IconCheck = styled('img')(() => ({
  width: '12px',
  height: '10px',
  marginRight: '5px',
}));

interface ArtistCardProps {
  data?: UserData;
  followsUser?: boolean;
  verified?: boolean;
}

// eslint-disable-next-line no-empty-pattern
const ArtistCard: React.FC<ArtistCardProps> = ({ data, followsUser }) => {
  const CardImg = require('assets/ArtistBg.png');
  const userImg = require('assets/Profile/buku_default_avatar.png');
  const authState = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const [followingUser, setFollowingUser] = React.useState<boolean>(false);
  React.useEffect(() => {
    const getFollowing = () => {
      if (authState && authState.following && data) {
        authState.following.some(
          following =>
            following.following.id === data.id && !following.unfollowed
        ) && setFollowingUser(true);
      }
    };
    getFollowing();
    //eslint-disable-next-line
  }, [authState.following, data]);
  const isOtherUser = (): boolean => {
    if (data) return authState.id !== data.id;
    else return false;
  };
  const navigate = useNavigate();
  const handleFollowUser = async () => {
    if (isOtherUser() && data) {
      if (followingUser) {
        data.followers = data.followers.filter(
          follower => follower.follower.id !== authState.id
        );
      } else {
        data.followers.push({
          id: v4(),
          followedAt: new Date(),
          followedDate: new Date(),
          follower: authState as UserData,
          following: data as UserData,
        });
      }
      await handleFollowing({
        authState,
        data: data as UserData,
        following: followingUser,
        setFollowing: setFollowingUser,
        dispatch,
      });
    }
  };
  return (
    <Card
      sx={{
        borderRadius: '25px',
        backgroundColor: '#313646',
        minHeight: '550px',
        width: '358px',
        marginRight: 0,
      }}
    >
      <CardActionArea sx={{ height: '100%' }}>
        <CardMedia
          component="img"
          height="210px"
          image={data?.banner || CardImg}
          alt="green iguana"
          sx={{ borderRadius: '25px' }}
        />
        {data && (
          <CardContent
            style={{
              position: 'relative',
              height: '100%',
              textAlign: 'center',
              padding: '20px 30px',
            }}
          >
            <ArtistAvatar
              alt={data.username}
              src={data.avatar || userImg}
              sx={{ width: 150, height: 150 }}
              onClick={() => navigate(`/profile/${data.username}/feed`)}
            />
            <div
              style={{
                display: 'flex',
                gap: 10,
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '20px',
              }}
            >
              <TitleText
                onClick={() => navigate(`/profile/${data.username}/feed`)}
              >
                {data.username}
              </TitleText>
              {data.verified && (
                <img src={IC_VERIFY} alt="" width="30px" height="30px" />
              )}
            </div>
            <NameText>@{data.username}</NameText>
            <ParaText>
              {data.bio ? (
                data.bio
              ) : (
                <div style={{ width: '100%', height: '70px' }}></div>
              )}
            </ParaText>
            <FollowersText>
              {data.followers ? data.followers.length : 0} followers
            </FollowersText>
            {isOtherUser() && (
              <NormalButton
                text={followingUser ? 'Unfollow' : 'Follow'}
                style={{
                  width: '200px',
                  background: '#FFFFFF1C',
                  color: '#A8AAB1',
                }}
                Icon={
                  followingUser ? (
                    <IconCheck src={IC_CHECK_WHITE} />
                  ) : (
                    <IconCheck src={IC_FOLLOW} />
                  )
                }
                onClick={handleFollowUser}
              />
            )}
          </CardContent>
        )}
      </CardActionArea>
    </Card>
  );
};

export default ArtistCard;
